var chunkMapping = {
	"webpack_container_remote_Remote_Header": [
		"webpack/container/remote/Remote/Header"
	],
	"webpack_container_remote_Remote_Footer": [
		"webpack/container/remote/Remote/Footer"
	],
	"webpack_container_remote_Remote_AIAssistant": [
		"webpack/container/remote/Remote/AIAssistant"
	],
	"webpack_container_remote_Remote_AgreementsModal": [
		"webpack/container/remote/Remote/AgreementsModal"
	],
	"webpack_container_remote_Remote_LearnComponentsProvider": [
		"webpack/container/remote/Remote/LearnComponentsProvider"
	],
	"webpack_container_remote_Remote_NotificationProvider": [
		"webpack/container/remote/Remote/NotificationProvider"
	],
	"webpack_container_remote_Remote_NotificationCarousel": [
		"webpack/container/remote/Remote/NotificationCarousel"
	],
	"webpack_container_remote_Remote_CategoriesProvider": [
		"webpack/container/remote/Remote/CategoriesProvider"
	],
	"webpack_container_remote_Remote_PointsProvider": [
		"webpack/container/remote/Remote/PointsProvider"
	],
	"webpack_container_remote_Remote_BackgroundAnimation": [
		"webpack/container/remote/Remote/BackgroundAnimation"
	],
	"webpack_container_remote_Remote_TitleBanner": [
		"webpack/container/remote/Remote/TitleBanner"
	],
	"webpack_container_remote_Remote_FeaturedBanner": [
		"webpack/container/remote/Remote/FeaturedBanner"
	],
	"webpack_container_remote_Remote_LargeBanner": [
		"webpack/container/remote/Remote/LargeBanner"
	],
	"webpack_container_remote_Remote_UserSummary": [
		"webpack/container/remote/Remote/UserSummary"
	],
	"webpack_container_remote_Remote_FeatureFlag": [
		"webpack/container/remote/Remote/FeatureFlag"
	],
	"webpack_container_remote_Remote_MultiListView": [
		"webpack/container/remote/Remote/MultiListView"
	],
	"webpack_container_remote_Remote_FeaturedListController": [
		"webpack/container/remote/Remote/FeaturedListController"
	],
	"webpack_container_remote_Remote_SearchControl": [
		"webpack/container/remote/Remote/SearchControl"
	],
	"webpack_container_remote_Remote_ObjectivesDrawer": [
		"webpack/container/remote/Remote/ObjectivesDrawer"
	],
	"webpack_container_remote_Remote_MediumBanner": [
		"webpack/container/remote/Remote/MediumBanner"
	],
	"webpack_container_remote_Remote_InfoSubBanner": [
		"webpack/container/remote/Remote/InfoSubBanner"
	],
	"webpack_container_remote_Remote_CourseDetails": [
		"webpack/container/remote/Remote/CourseDetails"
	],
	"webpack_container_remote_Remote_CurriculumDetails": [
		"webpack/container/remote/Remote/CurriculumDetails"
	],
	"webpack_container_remote_Remote_CategoryDetails": [
		"webpack/container/remote/Remote/CategoryDetails"
	],
	"webpack_container_remote_Remote_SearchBanner": [
		"webpack/container/remote/Remote/SearchBanner"
	],
	"webpack_container_remote_Remote_Transcript": [
		"webpack/container/remote/Remote/Transcript"
	],
	"webpack_container_remote_Remote_Gamification": [
		"webpack/container/remote/Remote/Gamification"
	],
	"webpack_container_remote_Remote_Achievements": [
		"webpack/container/remote/Remote/Achievements"
	],
	"webpack_container_remote_Remote_LearningAdvisor": [
		"webpack/container/remote/Remote/LearningAdvisor"
	],
	"webpack_container_remote_Remote_Panel": [
		"webpack/container/remote/Remote/Panel"
	],
	"webpack_container_remote_Remote_Leaderboard": [
		"webpack/container/remote/Remote/Leaderboard"
	],
	"webpack_container_remote_Remote_Badges": [
		"webpack/container/remote/Remote/Badges"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/Remote/Header": [
		"default",
		"./Header",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/Footer": [
		"default",
		"./Footer",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/AIAssistant": [
		"default",
		"./AIAssistant",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/AgreementsModal": [
		"default",
		"./AgreementsModal",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/LearnComponentsProvider": [
		"default",
		"./LearnComponentsProvider",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/NotificationProvider": [
		"default",
		"./NotificationProvider",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/NotificationCarousel": [
		"default",
		"./NotificationCarousel",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/CategoriesProvider": [
		"default",
		"./CategoriesProvider",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/PointsProvider": [
		"default",
		"./PointsProvider",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/BackgroundAnimation": [
		"default",
		"./BackgroundAnimation",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/TitleBanner": [
		"default",
		"./TitleBanner",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/FeaturedBanner": [
		"default",
		"./FeaturedBanner",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/LargeBanner": [
		"default",
		"./LargeBanner",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/UserSummary": [
		"default",
		"./UserSummary",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/FeatureFlag": [
		"default",
		"./FeatureFlag",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/MultiListView": [
		"default",
		"./MultiListView",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/FeaturedListController": [
		"default",
		"./FeaturedListController",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/SearchControl": [
		"default",
		"./SearchControl",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/ObjectivesDrawer": [
		"default",
		"./ObjectivesDrawer",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/MediumBanner": [
		"default",
		"./MediumBanner",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/InfoSubBanner": [
		"default",
		"./InfoSubBanner",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/CourseDetails": [
		"default",
		"./CourseDetails",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/CurriculumDetails": [
		"default",
		"./CurriculumDetails",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/CategoryDetails": [
		"default",
		"./CategoryDetails",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/SearchBanner": [
		"default",
		"./SearchBanner",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/Transcript": [
		"default",
		"./Transcript",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/Gamification": [
		"default",
		"./Gamification",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/Achievements": [
		"default",
		"./Achievements",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/LearningAdvisor": [
		"default",
		"./LearningAdvisor",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/Panel": [
		"default",
		"./Panel",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/Leaderboard": [
		"default",
		"./Leaderboard",
		"webpack/container/reference/Remote"
	],
	"webpack/container/remote/Remote/Badges": [
		"default",
		"./Badges",
		"webpack/container/reference/Remote"
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}